import React from 'react';
import PropTypes from 'prop-types';
import { useSortContext } from '../context/SortContext';
import styles from './SortButton.module.css';

const SortOptionsPanel = ({ showLeagueLocks = true }) => {
  const { sortSettings, updateSortSetting } = useSortContext();

  const handleLeagueLocksToggle = () => {
    updateSortSetting('showLeagueLocksGroup', !sortSettings.showLeagueLocksGroup);
  };

  const handleLeagueLocksSortToggle = () => {
    updateSortSetting('sortLeagueLocksByLockTime', !sortSettings.sortLeagueLocksByLockTime);
  };

  const handleGroupByChange = (value) => {
    updateSortSetting('groupBy', value);
  };

  const handleSortByChange = (value) => {
    updateSortSetting('sortBy', value);
  };

  const handleSortDirectionChange = () => {
    updateSortSetting('sortDirection', sortSettings.sortDirection === 'asc' ? 'desc' : 'asc');
  };

  return (
    <>
      {showLeagueLocks && (
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>League Locks</h4>
          <label className={styles.checkbox}>
            <input
              type="checkbox"
              checked={sortSettings.showLeagueLocksGroup}
              onChange={handleLeagueLocksToggle}
            />
            <span>Show League Locks Group</span>
          </label>
          {sortSettings.showLeagueLocksGroup && (
            <label className={styles.checkbox}>
              <input
                type="checkbox"
                checked={sortSettings.sortLeagueLocksByLockTime}
                onChange={handleLeagueLocksSortToggle}
              />
              <span>Sort League Locks on Lock Date & Time</span>
            </label>
          )}
        </div>
      )}

      <div className={styles.section}>
        <h4 className={styles.sectionTitle}>Group By</h4>
        <div className={styles.radioGroup}>
          <label className={styles.radio}>
            <input
              type="radio"
              name="groupBy"
              value="day"
              checked={sortSettings.groupBy === 'day'}
              onChange={(e) => handleGroupByChange(e.target.value)}
            />
            <span>Day</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="groupBy"
              value="conference"
              checked={sortSettings.groupBy === 'conference'}
              onChange={(e) => handleGroupByChange(e.target.value)}
            />
            <span>Conference</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="groupBy"
              value="league"
              checked={sortSettings.groupBy === 'league'}
              onChange={(e) => handleGroupByChange(e.target.value)}
            />
            <span>League (FBS/FCS)</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="groupBy"
              value="none"
              checked={sortSettings.groupBy === 'none'}
              onChange={(e) => handleGroupByChange(e.target.value)}
            />
            <span>No Grouping</span>
          </label>
        </div>
      </div>

      <div className={styles.section}>
        <h4 className={styles.sectionTitle}>Sort By</h4>
        <div className={styles.radioGroup}>
          <label className={styles.radio}>
            <input
              type="radio"
              name="sortBy"
              value="kickoff"
              checked={sortSettings.sortBy === 'kickoff'}
              onChange={(e) => handleSortByChange(e.target.value)}
            />
            <span>Kickoff Time (In Prog/Future/Past)</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="sortBy"
              value="chronological"
              checked={sortSettings.sortBy === 'chronological'}
              onChange={(e) => handleSortByChange(e.target.value)}
            />
            <span>Kickoff Time (No status Sort)</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="sortBy"
              value="teamRanking"
              checked={sortSettings.sortBy === 'teamRanking'}
              onChange={(e) => handleSortByChange(e.target.value)}
            />
            <span>Team Ranking</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="sortBy"
              value="spreadSize"
              checked={sortSettings.sortBy === 'spreadSize'}
              onChange={(e) => handleSortByChange(e.target.value)}
            />
            <span>Point Spread</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="sortBy"
              value="totalPoints"
              checked={sortSettings.sortBy === 'totalPoints'}
              onChange={(e) => handleSortByChange(e.target.value)}
            />
            <span>O/U Total</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="sortBy"
              value="homeTeam"
              checked={sortSettings.sortBy === 'homeTeam'}
              onChange={(e) => handleSortByChange(e.target.value)}
            />
            <span>Home Team (A-Z)</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="sortBy"
              value="awayTeam"
              checked={sortSettings.sortBy === 'awayTeam'}
              onChange={(e) => handleSortByChange(e.target.value)}
            />
            <span>Away Team (A-Z)</span>
          </label>
        </div>
      </div>

      <div className={styles.section}>
        <h4 className={styles.sectionTitle}>Direction</h4>
        <button
          type="button"
          className={styles.directionButton}
          onClick={handleSortDirectionChange}
        >
          {sortSettings.sortDirection === 'asc' ? '↑ Ascending' : '↓ Descending'}
        </button>
      </div>
    </>
  );
};

SortOptionsPanel.propTypes = {
  showLeagueLocks: PropTypes.bool
};

export default SortOptionsPanel;
